"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const LOCAL_STORAGE_KEY = 'notabene-jurisdictions';
const RULES_DEFAULT_TTL = 900;
class LocalStorageRulesProvider {
    constructor(provider, ttl = RULES_DEFAULT_TTL) {
        this.provider = provider;
        this.ttl = ttl;
    }
    getRules() {
        return __awaiter(this, void 0, void 0, function* () {
            let rules = this.getFromLocalStorage();
            if (rules)
                return rules;
            rules = yield this.provider.getRules();
            this.storeInLocalStorage(rules);
            return rules;
        });
    }
    /**
     * Gets rules that have been stored in local storage
     *
     * @returns Rules or null
     */
    getFromLocalStorage() {
        const item = window.localStorage.getItem(LOCAL_STORAGE_KEY);
        if (item === null)
            return null;
        try {
            const cachedRules = JSON.parse(item);
            if (cachedRules.expiry < new Date().getTime() - this.ttl)
                return null;
            return cachedRules.rules;
        }
        catch (err) {
            return null;
        }
    }
    /**
     * Stores rules in local storage
     *
     * @param rules The rules to store
     */
    storeInLocalStorage(rules) {
        const entry = {
            expiry: new Date().getTime() + this.ttl,
            rules,
        };
        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(entry));
    }
}
exports.default = LocalStorageRulesProvider;
